import { useEffect, useState } from 'react';

import AdminLayout from '../../Layouts/AdminLayout';

import BlockContent from '../../Components/Manager/BlockContent';
import { useNotification } from '../../Contexts/NotificationContext';

function App() {
    const { setNotification } = useNotification();
    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchContent = async () => {
        try {
            const response = await fetch(`${baseUrl}/manager/contatos/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                setContacts(data.contatos || []);
            } else {
                throw new Error('Erro ao buscar os contatos.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContent();
    }, []);

    const contentContacts = {
        nome: ['Contatos', 'contato'],
        route: 'contatos',
        imagens: false,
        editavel: true,
        conteudo: contacts,
        onUpdate: fetchContent,
    };

    return (
        <AdminLayout>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <div className="mt-4 grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                    <div className="col-span-12">
                        <BlockContent content={contentContacts} loading={loading} />
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}

export default App;
